// src/App.js
import React from 'react';
import Header from './components/Header';
// import Skills from './components/Skills';
// import Projects from './components/Projects';
// import Experience from './components/Experience';
// import Contact from './components/Contact';
import './App.css';

const App = () => {
    return (
        <div>
            <Header />
            {/* <Skills />
            <Projects />
            <Experience />
            <Contact /> */}
        </div>
    );
};

export default App;
